import React from "react"

const ListLoading = () => {
  return (
    <div className=" match-container result-container">
      <div className="loading-w-100 ">
        <div
          id="standard-image-container"
          className="standard-image-container w-100"
        >
          <p className="loading-imag-part shimmer-loading__para shimmer"></p>
        </div>
        <div className="w-100">
          <div className="details-text" id="details-text">
            <div className="d-flex flex-column">
              {Array.from({ length: 3 }, (_, index) => index + 1).map(val => (
                <p
                  key={val}
                  className="loading-part shimmer-loading__para shimmer"
                ></p>
              ))}
            </div>

            <div className="d-flex flex-column">
              {Array.from({ length: 2 }, (_, index) => index + 1).map(val => (
                <p
                  key={val}
                  className="loading-large-part shimmer-loading__para shimmer"
                ></p>
              ))}
            </div>

            <div className="d-flex">
              {Array.from({ length: 5 }, (_, index) => index + 1).map(val => (
                <p
                  key={val}
                  className="loading-small-part shimmer-loading__para shimmer"
                ></p>
              ))}
            </div>

            <div className="d-flex">
              {Array.from({ length: 2 }, (_, index) => index + 1).map(val => (
                <p
                  key={val}
                  className="loading-button-part shimmer-loading__para shimmer"
                ></p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListLoading
